import "./scss/_post-query-isotope.scss";
import lightbox from 'lightbox2';
import Isotope from 'isotope-layout';

function updateURLParameter(param, value) {
  const url = new URL(window.location.href);
  url.searchParams.set(param, value);
  history.pushState({}, '', url);
}

function getURLParameter(param) {
  const url = new URL(window.location.href);
  return url.searchParams.get(param);
}

function arrangeIsotope(iso, filterValue) {
  iso.arrange({ filter: filterValue });
  updateURLParameter('filter', filterValue);
}

function updateCheckedButton(filtersElem, filterValue) {
  filtersElem.forEach(button => {
    const buttonFilter = button.getAttribute('data-filter');
    button.classList.toggle('is-checked', buttonFilter === filterValue);
  });
}

document.addEventListener('DOMContentLoaded', () => {

  const iso_grid = new Isotope('.isotope-grid', {
    itemSelector: '.isotope-card',
    layoutMode: 'masonry',
    masonry: {
      gutter: 24,
    }
  });

  document.querySelector('.isotope-grid').classList.add('is-loaded');
  iso_grid.layout();

  const filtersElem = document.querySelectorAll('.isotope__filter-button-group .isotope__button');

  if (filtersElem) {
    filtersElem.forEach(button => {
      const filterValue = button.getAttribute('data-filter');
      const filterParam = getURLParameter('filter');

      button.addEventListener('click', () => {
        arrangeIsotope(iso_grid, filterValue);
        updateCheckedButton(filtersElem, filterValue);
      });

      if (filterParam === filterValue) {
        arrangeIsotope(iso_grid, filterValue);
        updateCheckedButton(filtersElem, filterValue);
      }
    });
  }

  const isoFilters = document.querySelector('.isotope-filters');

  if (isoFilters) {
    isoFilters.addEventListener('click', event => {
      if (event.target.matches(".isotope__button")) {
        const targetedButton = event.target;
        const targetedButtonGroup = targetedButton.parentElement;
        const filterGroup = targetedButtonGroup.getAttribute('data-filter-group');
        const filters = {};
        filters[filterGroup] = targetedButton.getAttribute('data-filter');
        const filterValue = Object.values(filters).join('');
        arrangeIsotope(iso_grid, filterValue);
      }
    });
  }

  const buttonGroups = document.querySelectorAll('.isotope__button-group');

  buttonGroups.forEach(buttonGroup => {
    buttonGroup.addEventListener('click', event => {
      if (event.target.matches('.isotope__button')) {
        buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
        event.target.classList.add('is-checked');
      }
    });
  });

  const dropdownButton = document.querySelectorAll('.isotope__dropdown-button');

  dropdownButton.forEach(button => {
    button.addEventListener('click', () => {
      const dropdownTarget = document.querySelector('.isotope__filter-button-group');
      dropdownTarget.classList.toggle('is-open');
    });
  });

  const buttonFilterAll = document.querySelectorAll('.isotope__button--all');

  buttonFilterAll.forEach(button => {
    button.addEventListener('click', () => {
      const dropdownTarget = document.querySelector('.isotope__filter-button-group');
      dropdownTarget.classList.toggle('is-open');
    });
  });
});
